var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.5C8.5 15.567 10.067 14 12 14C13.933 14 15.5 15.567 15.5 17.5C15.5 19.433 13.933 21 12 21C10.067 21 8.5 19.433 8.5 17.5Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5C2 4.567 3.567 3 5.5 3C7.433 3 9 4.567 9 6.5C9 8.433 7.433 10 5.5 10C3.567 10 2 8.433 2 6.5Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5C15 4.567 16.567 3 18.5 3C20.433 3 22 4.567 22 6.5C22 8.433 20.433 10 18.5 10C16.567 10 15 8.433 15 6.5Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.901d8c24aca20dabcc0eee7b3fba96fb.svg";
export { ForwardRef as ReactComponent };